import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-background-100 to-primary-950 border-t border-background-300/50">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-play-fill text-lg text-background-50" />
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">在线播放</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一个专注免费高清视频浏览的演示平台，汇集电影、电视剧与综艺内容，让找片与看片都更轻松。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">综艺频道</Link></li>
              <li><Link to="/search?q=科幻" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">热门标签</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快捷入口</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">网站首页</Link></li>
              <li><Link to="/category/movie/filter" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">筛选排序</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">友情提示</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              本站为演示站点，全部内容均为虚构示例，不提供真实播放、下载或付费服务。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center">
                <i className="ri-mail-line text-foreground-700" />
              </span>
              <span className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center">
                <i className="ri-share-line text-foreground-700" />
              </span>
              <span className="w-9 h-9 rounded-md bg-background-200/70 flex items-center justify-center">
                <i className="ri-heart-3-line text-foreground-700" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 在线播放 · 高清免费视频播放平台（演示站点）</p>
          <p>所有内容为虚构示例，仅用于产品演示。</p>
        </div>
      </div>
    </footer>
  );
}